import React, { useEffect, useRef, useState } from 'react'
import Navbar from './components/Navbar/Navbar'
import classes from './App.module.css'
import Home from './components/Home/Home'
import About from './components/About/About'
import Contact from './components/Contact/Contact'
import Portfolio from './components/Portfolio/Portfolio'
import { useOnScreen } from './hooks/useOnScreen'

const App = () => {
  const time = useRef(1)
  const [page, setPage] = useState(0)
  const [scrolledToBottom, setScrolledToBottom] = useState(false)
  useEffect(() => {
    setTimeout(() => {
      time.current = 0
    }, 2000)
  }, [])

  const homeRef = useRef()
  const aboutRef = useRef()
  const portfolioRef = useRef()
  const contactRef = useRef()
  const wrapperRef = useRef()

  const homeOnscreen = useOnScreen(homeRef, wrapperRef)
  const aboutOnscreen = useOnScreen(aboutRef, wrapperRef)
  const portfolioOnscreen = useOnScreen(portfolioRef, wrapperRef)
  const contactOnscreen = useOnScreen(contactRef, wrapperRef)

  useEffect(() => {
    if (homeOnscreen) {
      setPage(0)
      setScrolledToBottom(false)
    } else if (aboutOnscreen) setPage(1)
    else if (portfolioOnscreen) setPage(2)
    else if (contactOnscreen) {
      setPage(3)
      setScrolledToBottom(true)
    }
  }, [homeOnscreen, aboutOnscreen, portfolioOnscreen, contactOnscreen])

  console.log({
    scrolledToBottom,
  })

  return (
    <div className={classes.App}>
      <Navbar page={page} />
      <div className={classes.wrapper} ref={wrapperRef}>
        <div
          style={{ minHeight: '100%' }}
          className={classes.container}
          id="home"
          ref={homeRef}
        >
          {(homeOnscreen || scrolledToBottom) && <Home time={time.current} />}
        </div>

        <div
          style={{ minHeight: '100%' }}
          className={classes.container}
          id="about"
          ref={aboutRef}
        >
          {(aboutOnscreen || scrolledToBottom) && <About />}
        </div>

        <div
          style={{ minHeight: '100%' }}
          className={classes.container}
          id="portfolio"
          ref={portfolioRef}
        >
          {(portfolioOnscreen || scrolledToBottom) && <Portfolio />}
        </div>

        <div
          style={{ minHeight: '100%' }}
          id="contact"
          ref={contactRef}
        >
          {contactOnscreen && <Contact />}
        </div>
      </div>
    </div>
  )
}

export default App
